module.exports = __webpack_public_path__ + "img/img_sub_ser_transformation_03.12ba226f.svg";